// React
import React, { useState } from 'react';

// Components
import {
  ADGMImage,
  ADGMAlert,
  ADGMSelect,
  ADGMTextField,
  ADGMDatePicker,
  ADGMCalenderField,
  ADGMTimePicker,
  ADGMCheckbox,
  ADGMButton,
} from 'aurora-components';
import { Avatar, Box, Divider, Grid, Typography, withStyles } from '@material-ui/core';
import ADGMItemDetails from 'aurora-components/ADGMItemDetails/ADGMItemDetails';

// utils
import PropTypes from 'prop-types';
import { keyEmptyCheck } from 'aurora-utils/utils';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';

// SVG
import TenantProfile from 'aurora-images/user_profile.svg';

// Styles
import styles from './styles';

const CHARS_TO_SHOW = 1000;
function getColSpace(fullWidth, colSpace, offSet) {
  if (offSet) return offSet;
  if (fullWidth) return 12;
  if (colSpace) return 12 / colSpace;
  return 6;
}
function ADGMPanelInputsGeneratorBody({ classes, sections, isEditable, withBorder, bodyStyle, dividerStyle }) {
  const [isReadMore, setIsReadMore] = useState(true);

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  if (isEmpty(sections)) {
    return null;
  }

  return sections?.map(({ title, error, fields, labels, entityInfo, id, ComponentUnderSection }, index) => {
    return (
      <div key={id} className={(withBorder && classes.Border, bodyStyle)}>
        <Grid container spacing={2} key={title} className={classNames(classes.containerPadding)}>
          {((isEditable && error) || title) && (
            <Grid item xs={12} className={classes.titleWrapper}>
              {title && (
                <Typography variant='h6' className={classes.sectionTitle}>
                  {title}
                </Typography>
              )}
              {isEditable && error && (
                <ADGMAlert className='fullWidth' type='info'>
                  {error}
                </ADGMAlert>
              )}
            </Grid>
          )}
          {entityInfo && (
            <Grid item xs={12}>
              <Box item sx={{ gridRow: '1 / 3' }} className={classes.ownerDetailHolder}>
                <div>
                  <Typography variant='subtitle1'>
                    <Typography variant='subtitle1' className={classes.strongText}>
                      <Avatar alt='avatar' src={TenantProfile} className={classes.ownerAvatarimg} />
                      {keyEmptyCheck('buyer')}# {index + 1}
                    </Typography>

                    {/* Styles */}
                    {entityInfo?.nameEn}
                  </Typography>
                  <Typography variant='subtitle1' className={classNames(classes.strongText, classes.textAr)}>
                    {entityInfo?.nameAr}
                  </Typography>
                </div>
              </Box>
            </Grid>
          )}
          {isEditable ? (
            <>
              {fields?.map(
                ({
                  type,
                  component,
                  hint,
                  infoHint,
                  fullWidth,
                  offSet,
                  dateComponentProps,
                  colSpace,
                  ...fieldProps
                }) => {
                  return (
                    <>
                      <Grid
                        item
                        xs={12}
                        lg={getColSpace(fullWidth, colSpace, offSet)}
                        key={fieldProps.name}
                        className={{
                          [classes.buttonPlacement]: type === 'button',
                          [classes.checkboxPlacement]: type === 'checkbox',
                        }}
                      >
                        {(type === 'text' || type === 'number') && <ADGMTextField type={type} {...fieldProps} />}
                        {type === 'dropdown' && <ADGMSelect {...fieldProps} />}
                        {type === 'textarea' && (
                          <ADGMTextField type={type} {...fieldProps} textArea minRows={2} fullWidth={fullWidth} />
                        )}
                        {type === 'date' && (
                          <ADGMDatePicker
                            {...fieldProps}
                            component={
                              <ADGMCalenderField
                                {...dateComponentProps}
                                mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                              />
                            }
                          />
                        )}
                        {type === 'time' && <ADGMTimePicker {...fieldProps} />}
                        {type === 'button' && <ADGMButton {...fieldProps} />}
                        {type === 'checkbox' && <ADGMCheckbox {...fieldProps} />}
                        {type === 'customComponent' && component}
                        {!isEmpty(hint) && (
                          <Box className={classes.hintText}>
                            <p>{hint?.left}</p>
                            <p>{hint?.right}</p>
                          </Box>
                        )}

                        {infoHint && (
                          <Box className={classes.hintText}>
                            <ADGMAlert type='mute' noBackground>
                              {infoHint}
                            </ADGMAlert>
                          </Box>
                        )}
                      </Grid>
                    </>
                  );
                },
              )}
              {ComponentUnderSection && ComponentUnderSection}
            </>
          ) : (
            /* eslint-disable react/no-array-index-key */
            labels?.map(({ label, value, colSpace = 3, fullWidth, isTextArea, ...rest }, idx) => {
              if (isTextArea) {
                return (
                  <Grid item xs={12} sm={12}>
                    <Typography variant='body1' className={classes.label}>
                      {isReadMore ? labels[0].value.slice(0, CHARS_TO_SHOW) : labels[0].value}
                      {labels[0].value.length > CHARS_TO_SHOW ? <Divider className={classes.marginCls} /> : ''}
                      <div className={classes.readMoreCls}>
                        {labels[0].value.length > CHARS_TO_SHOW ? (
                          // eslint-disable-next-line jsx-a11y/interactive-supports-focus, jsx-a11y/click-events-have-key-events
                          <div className={classes.readMoreLink} onClick={toggleReadMore} role='button'>
                            <span>{isReadMore ? keyEmptyCheck('read_more') : keyEmptyCheck('show_less')}</span>
                            <ADGMImage
                              className={classes.iconCls}
                              name={isReadMore ? 'arrow-down-black.svg' : 'arrow-up-black.svg'}
                              alt='read_more'
                            />
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    </Typography>
                  </Grid>
                );
              }
              return (
                <Grid
                  item
                  xs={12}
                  md={getColSpace(fullWidth, colSpace)}
                  className={classes.gridItem}
                  key={`${idx}${label}${value}`}
                >
                  <Typography variant='body1' className={classes.label}>
                    <ADGMItemDetails label={label} value={value} {...rest} />
                  </Typography>
                </Grid>
              );
            })
          )}
        </Grid>
        {index < sections.length - 1 && <Divider className={classNames(classes.divider, dividerStyle)} />}
      </div>
    );
  });
}

ADGMPanelInputsGeneratorBody.propTypes = {
  classes: PropTypes.object.isRequired,
  isEditable: PropTypes.object.isRequired,
  onlyText: PropTypes.string.isRequired,
  withBorder: PropTypes.bool,
  bodyStyle: PropTypes.string,
  dividerStyle: PropTypes.string,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      error: PropTypes.string,
      fields: PropTypes.arrayOf(
        PropTypes.shape({
          placeholder: PropTypes.string.isRequired,
          type: PropTypes.oneOf(['dropdown, text']).isRequired,
          hint: PropTypes.object,
          infoHint: PropTypes.string,
          required: PropTypes.bool.isRequired,
          label: PropTypes.string.isRequired,
          colSpace: PropTypes.number,
          options: PropTypes.arrayOf(
            PropTypes.shape({
              value: PropTypes.string.isRequired,
              label: PropTypes.string.isRequired,
            }),
          ),
        }),
      ),
    }),
  ).isRequired,
};
ADGMPanelInputsGeneratorBody.defaultProps = {
  withBorder: false,
  bodyStyle: undefined,
  dividerStyle: undefined,
};
export default withStyles(styles)(ADGMPanelInputsGeneratorBody);
